import { App } from "./ui/app";
import { MotionDetectionAdapter } from "./detect/motion";
import { VideoFileAdapter } from "./detect/videoFile";
import "./styles.css";

const root = document.getElementById("app");
if (!root) throw new Error("geen #app element");

const app = new App(root);
app.render();

// PWA-serviceworker (alleen waar toegestaan)
if ("serviceWorker" in navigator && (location.protocol === "https:" || location.hostname === "localhost" || location.hostname === "127.0.0.1")) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("./sw.js").catch(() => {
      /* offline cache is bonus, geen blokkade */
    });
  });
}

// Exposeer voor debuggen op de telefoon (locatie-verificatie)
(window as unknown as Record<string, unknown>).bsv2app = app;

// Fase 2: detectie-laag beschikbaar voor headless meetdrivers.
(window as unknown as Record<string, unknown>).bsv2detect = {
  MotionDetectionAdapter,
  VideoFileAdapter,
};
